import { render } from "./Body.vue?vue&type=template&id=381daeda"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"
script.render = render

export default script